export interface Equipment {
  name: string;
  description: string;
  capabilities: string[];
  icon: string;
  image: string;
}

export const equipmentList: Equipment[] = [
  {
    name: 'Backhoe',
    description:
      'Versatile machine for excavation, trenching, and material handling operations.',
    capabilities: [
      'Excavation and digging',
      'Trenching for utilities',
      'Material loading',
      'Site clearing',
    ],
    icon: 'Tractor',
    image:
      'https://daswell.com/wp-content/uploads/2025/04/how-to-operate-the-backhoe-loader.jpg',
  },
  {
    name: 'Excavator',
    description:
      'Heavy-duty machine for large-scale earthmoving and deep excavation projects.',
    capabilities: [
      'Deep excavation',
      'Foundation digging',
      'Heavy lifting',
      'Demolition support',
    ],
    icon: 'Construction',
    image:
      'https://images.pexels.com/photos/1078884/pexels-photo-1078884.jpeg?auto=compress&cs=tinysrgb&w=800',
  },
  {
    name: 'Skid Steer',
    description:
      'Compact and maneuverable loader ideal for tight spaces and varied tasks.',
    capabilities: [
      'Material moving',
      'Grading and leveling',
      'Debris removal',
      'Tight space operation',
    ],
    icon: 'Truck',
    image:
      'https://marvel-b1-cdn.bc0a.com/f00000000083059/titanmachinery.blob.core.windows.net/titan-production-blob/images/default-source/landing-page-images/web_version_150-9w6a0261.jpg?sfvrsn=7bd99237_0',
  },
  {
    name: 'Forklift',
    description:
      'Essential for material handling, lifting, and positioning heavy loads on site.',
    capabilities: [
      'Material lifting',
      'Pallet handling',
      'Load positioning',
      'Warehouse operations',
    ],
    icon: 'Package',
    image:
      'https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=800',
  },
  {
    name: 'Scaffolding',
    description:
      'Safe elevated work platforms for construction, finishing, and maintenance work.',
    capabilities: [
      'Elevated access',
      'Multi-level work platforms',
      'Safety compliance',
      'Flexible configurations',
    ],
    icon: 'Grid3X3',
    image:
      'https://lh3.googleusercontent.com/gps-cs-s/APNQkAHTW0geNYrV0Tw1PgBoZkLZWNC7Hd1WzzCJ1N2uo_cxNUOVvTJfDRxG-u4vnfgMJfdNXpBaOCSrXV7iyFH9-hih8kIoA8Md4DQGbsmuJ65QQDjxZvpgi1Wz1PZieVWC1b318fuTAg=s1360-w1360-h1020-rw',
  },
  {
    name: 'Prop Rental',
    description:
      'Formwork support systems for concrete construction and slab work.',
    capabilities: [
      'Slab support',
      'Formwork shoring',
      'Load distribution',
      'Adjustable heights',
    ],
    icon: 'Columns',
    image:
      'https://www.alborz-ghaleb.com/wp-content/uploads/2023/05/Untitled.jpg',
  },
];
